module.exports = __webpack_public_path__ + "static/media/20.7c1ece1c.jpg";